var rtl_rtlignore_default = {
  "rtl": "g6mjL",
  "ltr": "A7P7a"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
